import { Routes, Route, Navigate } from "react-router-dom";
import Chat from "./components/Chat/Chat";
import ScheduleEditor from "./components/ScheduleEditor/ScheduleEditor";
import Workspace from "./components/Workspace/Workspace";
import TkadlecMemoriesPage from "./components/TkadlecMemories/TkadlecMemoriesPage";
import Settings from "./components/Settings/Settings";
import Admin from "./components/Admin/Admin";
import Devices from "./components/Devices/Devices";
import AnnaCore from "./components/AnnaCore/AnnaCore";
import SingularityNode from "./components/SingularityNode/SingularityNode";
import Weather from "./components/Weather/Weather";
import TkadlecSnu from "./components/TkadlecSnu/TkadlecSnu";
import HuginnPrompt from "./components/Admin/HuginnPrompt";
import IreneSessions from "./components/Irene/IreneSessions";
import AuraSessions from "./components/Aura/AuraSessions";
import HouseMap from "./components/HouseMap/HouseMap";
import DeviceOta from "./components/DeviceOta/DeviceOta";
import Usporadatel from "./components/Usporadatel/Usporadatel";
import Auth from "./components/Auth/Auth";
import AuthCallback from "./components/Auth/AuthCallback";
import SpotifyCallback from "./components/Auth/SpotifyCallback";
import Layout from "./components/Layout/Layout";
import Notifications from "./components/Notifications/Notifications";
import { AuthProvider } from "./hooks/useAuth";

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/auth" element={<Auth />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/auth/spotify/callback" element={<SpotifyCallback />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Navigate to="/chat" replace />} />
          <Route path="/calendar" element={<Navigate to="/workspace" replace />} />
          <Route path="/schedule/new" element={<ScheduleEditor />} />
          <Route path="/schedule/:id" element={<ScheduleEditor />} />
          <Route path="/workspace" element={<Workspace />} />
          <Route path="/reminders" element={<Navigate to="/workspace" replace />} />
          <Route path="/ideas" element={<Navigate to="/workspace#ideas" replace />} />
          <Route path="/chat" element={<Chat key="anna" profile="doppelganger" />} />
          <Route path="/doppelganger" element={<Navigate to="/chat" replace />} />
          <Route path="/notifications" element={<Notifications active />} />
          <Route path="/memories" element={<TkadlecMemoriesPage />} />
          <Route path="/devices" element={<Devices />} />
          <Route path="/anna-core" element={<AnnaCore />} />
          <Route path="/singularity-node" element={<SingularityNode />} />
          <Route path="/weather" element={<Weather />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/tkadlec" element={<TkadlecSnu />} />
          <Route path="/huginn" element={<HuginnPrompt />} />
          <Route path="/irene" element={<IreneSessions />} />
          <Route path="/aura" element={<AuraSessions />} />
          <Route path="/house-map" element={<HouseMap />} />
          <Route path="/device-ota" element={<DeviceOta />} />
          <Route path="/usporadatel" element={<Usporadatel />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
